module.exports = __webpack_public_path__ + "static/media/bar4.96f865df.jpg";